import React from 'react';
import { Button, Card, CardBody, CardImg, CardSubtitle, CardText } from 'reactstrap';
import { useEffect, useState } from 'react';
import Moment from 'moment';
import TextTruncate from 'react-text-truncate';

const ReportCard = ({ data, toReport, modules, shortenText }) => {
	const { images, reportId, address, insertDate, description, type } = data;

	// Wird für die Höhe der Bilder benötigt
	const useMediaQuery = query => {
		const mediaMatch = window.matchMedia(query);
		const [matches, setMatches] = useState(mediaMatch.matches);

		useEffect(() => {
			const handler = e => setMatches(e.matches);
			mediaMatch.addListener(handler);
			return () => mediaMatch.removeListener(handler);
		});
		return matches;
	};

	// Styles passen sich automatisch an die Bildschirmbreite an.
	const styles = {
		container: (isBig, isSmaller) => ({
			maxHeight: isBig ? '195px' : isSmaller ? '270px' : 'none',
			objectFit: 'cover'
		})
	};

	const isBig = useMediaQuery('(min-width: 1200px)');
	const isSmaller = useMediaQuery('(min-width: 576px)');
	return (
		<Card className="overflow-hidden">
			<CardImg
				top
				width="100%"
				style={styles.container(isBig, isSmaller)}
				src={images[0] ? images[0].thumbnail : 'assets/images/noimage.svg'}
				alt="Card image cap"
			/>
			<CardBody style={{ padding: 20 }}>
				<h4 className="card-title">{`${type.description}`}</h4>
				{
					// <h3 className="card-title">{`Meldung ${reportId}`}</h3>
					//<CardSubtitle>{Moment(insertDate).format('DD.MM.YYYY hh:mm')}</CardSubtitle>
				}
				<CardText>
					{shortenText ? (
						<TextTruncate key={new Date().getTime()} line={5} element="span" truncateText="…" text={description} />
					) : (
						description
					)}
				</CardText>
				{modules && modules.reportDetails && (
					<Button color="primary" onClick={() => toReport(reportId)}>
						Mehr
					</Button>
				)}
			</CardBody>
		</Card>
	);
};
export default ReportCard;



// WEBPACK FOOTER //
// ./components/ReportCard/index.js